import { ref } from "vue";
import { projectFirestore } from "../firebase/config";
import { useStore } from "vuex";
import { useRoute } from "vue-router";


const updateError = ref(null);
const categoryPositioning = ref([])
const support_lib_id = ref('')

const getUserCategoryPositioning = (path = undefined) => {
    const store = useStore();
    const hlpt_support_library_id = store.state.parent_lib_id;
    const route = useRoute()
    const isCategoryPositioningLoading = ref(false)

    const updateCategoryPositioning = async (categoryArr) => {
        const unique = categoryArr.filter((obj, index) => {
            return index === categoryArr.findIndex(o => obj.id === o.id);
        });

        let categoryPositioningObj = { categoryPositioning: unique };

        categoryPositioning.value = unique;
        const parent = route.matched[route.matched.length - 2];
        if (!['Frontend', 'AdvancedWidget', 'Home'].includes(parent?.name)) {

            try {
                await projectFirestore.collection('SupportLibraries').doc(support_lib_id.value).set(categoryPositioningObj, { merge: true });;
            } catch (err) {
                store.dispatch('printLog', {text:'Error while updating:', log:err});
                updateError.value = 'Error while updating';
            }
        }
    };

    // Call the function with your data
    // updateCategoryPositioning(yourCategoryArray);


    const createCategoryPositioning = async () => {
        let lib_ids = hlpt_support_library_id ? [hlpt_support_library_id, support_lib_id.value] : [support_lib_id.value]

        await projectFirestore.collection("Categories").where('support_lib_id', 'in', lib_ids).orderBy('category_title').get().then(async (snap) => {
            if (!snap.empty) {
                
                const data = snap.docs.map((doc) => {
                    return { ...doc.data(), id: doc.id, articles: [], subCategory: [] }
                })
                let libCats = data.filter((cat) => cat.support_lib_id === support_lib_id.value)
                let hlptCats = data.filter((cat) => cat.support_lib_id === hlpt_support_library_id)
                let categories = [...libCats, ...hlptCats]
                let subCategories = categories.filter((cat) => cat.parent_cat_id)
                let payload = categories.filter((cat) => !cat.parent_cat_id)
                payload.forEach((cat) => {
                    cat.subCategory = subCategories?.filter((sub) => sub.parent_cat_id === cat.id) || []
                })
                await updateCategoryPositioning(payload);
            }
        })
    }

    const getCategoryPositioning = async (lib_id) => {
        isCategoryPositioningLoading.value = true
        categoryPositioning.value = []
        support_lib_id.value = lib_id
        try {
            const doc = await projectFirestore.collection("SupportLibraries").doc(lib_id).get();
            if (doc.exists && doc.data()?.categoryPositioning) {

                let lib_ids = hlpt_support_library_id ? [hlpt_support_library_id, lib_id] : [lib_id]
                // console.log('going in else if')
                categoryPositioning.value = doc.data().categoryPositioning.length ? JSON.parse(JSON.stringify(doc.data().categoryPositioning)) : [];

                await projectFirestore.collection('Categories').where('support_lib_id', 'in', lib_ids).get().then(async (snapshot) => {

                    let defaultCats = [];

                    if (!snapshot.empty) {
                        defaultCats = snapshot.docs.filter((el) => {
                                const data = el.data();
                                if (hlpt_support_library_id && data.support_lib_id === hlpt_support_library_id) {
                                    return data.is_enabled !== false;
                                }
                                return true;
                            }).map((el) => ({ id: el.id, ...el.data() }));

                    }

                    // Create a map of existing category IDs for efficient lookups
                    const existingIds = new Set(categoryPositioning.value.map(cat => cat.id));

                    // Add new parent categories and their subcategories
                    const parentCats = defaultCats.filter(cat => !cat.parent_cat_id);

                   const allChildCategories = snapshot.docs.filter((el) =>
                        el.data().is_enabled == true 
                        && el.data().parent_cat_id
                    ).map((el) => (el.id ));
                    

                    for (let i = 0; i < parentCats.length; i++) {
                        const parentCat = parentCats[i];

                        // Check if parent already exists
                        let parentIndex = categoryPositioning.value.findIndex(c => c.id === parentCat.id);
                        
                        //if parent category is_enabled is false, then remove it from the categoryPositioning and also remove all its subcategories only for child support library
                        if (parentCat.is_enabled === false && hlpt_support_library_id && parentIndex !== -1) {
                            if(parentCat.support_lib_id == hlpt_support_library_id) {
                                categoryPositioning.value.splice(parentIndex, 1);
                            }
                            if(categoryPositioning.value[parentIndex]?.subCategory?.length) {
                                categoryPositioning.value[parentIndex].subCategory.forEach((sub, j) => {
                                    if(sub.support_lib_id === hlpt_support_library_id && parentCat.id === sub.parent_cat_id) {
                                        categoryPositioning.value[parentIndex].subCategory.splice(j, 1);
                                    }
                                })
                            }
                            continue;
                        }

                        // If not found, push it
                        if (parentIndex === -1) {
                            categoryPositioning.value.push({
                                ...parentCat,
                                subCategory: parentCat.subCategory ? parentCat.subCategory : [],
                                articles: parentCat.articles ? parentCat.articles : []
                            });
                            existingIds.add(parentCat.id);
                            parentIndex = categoryPositioning.value.length - 1;
                        }

                        // Ensure subCategory array exists
                        if (!Array.isArray(categoryPositioning.value[parentIndex]?.subCategory)) {
                            categoryPositioning.value[parentIndex] = {
                                ...categoryPositioning.value[parentIndex],
                                subCategory: []
                            }
                        }

                        // Add subcategories of this parent
                        const subCats = defaultCats.filter(c => c.parent_cat_id === parentCat.id);
                        const existingSubIds = new Set(
                            categoryPositioning.value[parentIndex].subCategory.map(sc => sc.id)
                        );

                        for (let j = 0; j < subCats.length; j++) {
                            const subCat = subCats[j];
                            if (!existingSubIds.has(subCat.id)) {
                                categoryPositioning.value[parentIndex].subCategory.push({...subCat, articles: []});
                                existingSubIds.add(subCat.id);
                            }
                        }
                    }

                    // Remove categories that are no longer present in defaultCats
                    const idxArr2 = defaultCats.map(cat => cat.id);
                    const elementsToRemove = [];

                    for (let i = 0; i < categoryPositioning.value.length; i++) {
                        const cat = categoryPositioning.value[i];

                        // If this main category is not in defaultCats → mark for removal
                        if (!idxArr2.includes(cat.id)) {
                            // Remove subcategories not in defaultCats
                            const subElementsToRemove = [];

                            for (let j = 0; j < cat.subCategory.length; j++) {
                            const sub = cat.subCategory[j];
                            if (!idxArr2.includes(sub.id)) {
                                subElementsToRemove.push(j);
                            }
                            }

                            for (let j = subElementsToRemove.length - 1; j >= 0; j--) {
                                cat.subCategory.splice(subElementsToRemove[j], 1);
                            }

                            // Mark main category for removal
                            elementsToRemove.push(i);
                        }

                        if(cat?.subCategory?.length) {
                            const toRemove = [];
                            cat.subCategory.forEach((sub, j) => {
                                if (!allChildCategories.includes(sub.id)) {
                                    toRemove.push(j);
                                }
                            })

                            for (let j = toRemove.length - 1; j >= 0; j--) {
                                cat.subCategory.splice(toRemove[j], 1);
                            }
                        }
                    }

                    for (let k = elementsToRemove.length - 1; k >= 0; k--) {
                        categoryPositioning.value.splice(elementsToRemove[k], 1);
                    }

                    // Sync mutable metadata (title, is_enabled, is_disabled, icon, description)
                    // from the fresh DB record into the stored positioning so the stored
                    // object never drifts from the Categories collection.
                    const parentCats2 = defaultCats.filter(cat => !cat.parent_cat_id);

                    const syncCatMeta = (target, source) => {
                        target.category_title = source.category_title;
                        target.support_lib_id = source.support_lib_id;
                        if (source.category_icon !== undefined) {
                            target.category_icon = source.category_icon;
                        }
                        if (source.category_description !== undefined) {
                            target.category_description = source.category_description;
                        }
                        if (source.is_disabled !== undefined) {
                            target.is_disabled = source.is_disabled;
                        }
                        // Always reflect the DB value of is_enabled (including when DB has
                        // flipped it back to true) so stale false values don't persist.
                        if (source.is_enabled !== undefined) {
                            target.is_enabled = source.is_enabled;
                        } else {
                            delete target.is_enabled;
                        }
                    };

                    for (let i = 0; i < parentCats2.length; i++) {
                        const parentCat = parentCats2[i];
                        const parentIndex = categoryPositioning.value.findIndex(c => c.id === parentCat.id);

                        if (parentIndex !== -1) {
                            syncCatMeta(categoryPositioning.value[parentIndex], parentCat);

                            // Update subcategories
                            const subCategories = defaultCats.filter(c => c.parent_cat_id === parentCat.id);
                            for (let j = 0; j < subCategories.length; j++) {
                                const subCat = subCategories[j];
                                const subIndex = categoryPositioning.value[parentIndex]?.subCategory?.findIndex(s => s.id === subCat.id);

                                if (subIndex !== undefined && subIndex !== -1) {
                                    syncCatMeta(categoryPositioning.value[parentIndex].subCategory[subIndex], subCat);
                                }
                            }
                        }
                    }

                    // console.log('categoryPositioning.value', categoryPositioning.value);
                    await updateCategoryPositioning(categoryPositioning.value);
                });
            } else {
                createCategoryPositioning()
            }
        } catch (error) {
             store.dispatch('printLog', {text:'Error while getting categoryPositioning:', log:error});
            updateError.value = 'Error while getting categoryPositioning';
        } finally {
            isCategoryPositioningLoading.value = false
        }
    }

    return { getCategoryPositioning, categoryPositioning, updateError, isCategoryPositioningLoading }
}

export default getUserCategoryPositioning